module.exports = __webpack_public_path__ + "static/media/cases_3d_07a.9bb8a9fb.jpg";